import { Box, Flex, Icon, Tooltip } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

interface EnterEstimateBadgeProps {
    canEnter: boolean;
    boxSize?: string;
    showWhenCanEnter?: boolean;
}

const EnterEstimateBadge = ({ canEnter, boxSize = '12px', showWhenCanEnter = false }: EnterEstimateBadgeProps) => {
    if (canEnter && !showWhenCanEnter) return null;

    const color = canEnter ? '#2F855A' : '#E53E3E'; // green.500 / red.500

    return (
        <Tooltip
            label={canEnter
                ? "You're good to go into the estimate!"
                : "We are accessing this estimate and we'll be done in a few minutes. Wait until this goes away, or you get a notification, before entering it."}
            placement="top"
            hasArrow
            maxW="280px"
        >
            {canEnter ? (
                <Flex
                    display="inline-flex"
                    onClick={(e) => e.stopPropagation()}
                    w={boxSize}
                    h={boxSize}
                    borderRadius="full"
                    flexShrink={0}
                    bg={color}
                    align="center"
                    justify="center"
                >
                    <Icon as={CheckIcon} w="55%" h="55%" color="white" />
                </Flex>
            ) : (
                <Flex
                    display="inline-flex"
                    onClick={(e) => e.stopPropagation()}
                    w={boxSize}
                    h={boxSize}
                    borderRadius="full"
                    flexShrink={0}
                    border="2px solid"
                    borderColor={color}
                    bg="white"
                    align="center"
                    justify="center"
                >
                    <Box w="50%" h="50%" borderRadius="full" bg={color} />
                </Flex>
            )}
        </Tooltip>
    );
};

export default EnterEstimateBadge;
